import { useEffect, useState } from "react";
import {
  fetchAcademyCategories,
  createAcademyCategory,
  deleteAcademyCategory,
} from "@/api/academyAuth";

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({
    name: "",
    parent_id: null,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // تحميل الفئات
  const loadCategories = async () => {
    try {
      const data = await fetchAcademyCategories();
      setCategories(data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    loadCategories();
  }, []);

  // إضافة فئة
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      await createAcademyCategory({
        name: form.name,
        parent_id: form.parent_id,
      });

      setForm({ name: "", parent_id: null });
      setSuccess("تم إضافة الفئة بنجاح!");
      loadCategories();
    } catch (e) {
      console.error(e);
      setError("فشل إضافة الفئة. الرجاء المحاولة مرة أخرى.");
    } finally {
      setLoading(false);
    }
  };

  // حذف فئة
  const handleDelete = async (id) => {
    if (!window.confirm("هل أنت متأكد من حذف هذه الفئة؟\nسيتم حذف جميع الفئات الفرعية التابعة لها أيضاً.")) return;

    try {
      await deleteAcademyCategory(id);
      setSuccess("تم حذف الفئة بنجاح!");
      loadCategories();
    } catch (e) {
      console.error(e);
      setError("فشل حذف الفئة. الرجاء المحاولة مرة أخرى.");
    }
  };

  // أنماط CSS
  const styles = {
    container: {
      padding: "30px",
      minHeight: "100vh",
      backgroundColor: "#f8f9fa",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "30px",
      paddingBottom: "15px",
      borderBottom: "2px solid #4b6cb7"
    },
    title: {
      margin: "0",
      color: "#182848",
      fontSize: "28px",
      fontWeight: "700"
    },
    card: {
      backgroundColor: "white",
      borderRadius: "15px",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.05)",
      padding: "25px",
      marginBottom: "30px"
    },
    cardTitle: {
      margin: "0 0 20px 0",
      color: "#182848",
      fontSize: "20px",
      fontWeight: "600",
      display: "flex",
      alignItems: "center",
      gap: "10px"
    },
    form: {
      display: "flex",
      flexDirection: "column",
      gap: "20px"
    },
    formGroup: {
      display: "flex",
      flexDirection: "column",
      gap: "8px"
    },
    label: {
      color: "#495057",
      fontWeight: "500",
      fontSize: "15px"
    },
    input: {
      padding: "12px 15px",
      border: "1px solid #e1e5eb",
      borderRadius: "10px",
      fontSize: "16px",
      transition: "all 0.3s",
      backgroundColor: "#f8f9fa",
      boxSizing: "border-box",
      fontFamily: "inherit"
    },
    select: {
      padding: "12px 15px",
      border: "1px solid #e1e5eb",
      borderRadius: "10px",
      fontSize: "16px",
      transition: "all 0.3s",
      backgroundColor: "#f8f9fa",
      boxSizing: "border-box",
      fontFamily: "inherit",
      cursor: "pointer"
    },
    inputFocus: {
      outline: "none",
      borderColor: "#4b6cb7",
      boxShadow: "0 0 0 3px rgba(75, 108, 183, 0.1)",
      backgroundColor: "white"
    },
    button: {
      padding: "14px 25px",
      background: "linear-gradient(90deg, #4b6cb7 0%, #182848 100%)",
      color: "white",
      border: "none",
      borderRadius: "10px",
      fontSize: "16px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.3s",
      alignSelf: "flex-start",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      fontFamily: "inherit"
    },
    buttonDisabled: {
      opacity: "0.7",
      cursor: "not-allowed"
    },
    deleteButton: {
      padding: "6px 12px",
      backgroundColor: "#dc3545",
      color: "white",
      border: "none",
      borderRadius: "6px",
      fontSize: "14px",
      cursor: "pointer",
      transition: "all 0.3s",
      fontWeight: "500"
    },
    successMessage: {
      backgroundColor: "#d4edda",
      border: "1px solid #c3e6cb",
      color: "#155724",
      padding: "12px 15px",
      borderRadius: "10px",
      marginTop: "15px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      fontSize: "15px"
    },
    errorMessage: {
      backgroundColor: "#f8d7da",
      border: "1px solid #f5c6cb",
      color: "#721c24",
      padding: "12px 15px",
      borderRadius: "10px",
      marginTop: "15px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      fontSize: "15px"
    },
    spinner: {
      width: "18px",
      height: "18px",
      border: "2px solid rgba(255, 255, 255, 0.3)",
      borderRadius: "50%",
      borderTopColor: "white",
      animation: "spin 1s ease-in-out infinite"
    },
    categoriesContainer: {
      backgroundColor: "white",
      borderRadius: "15px",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.05)",
      padding: "25px"
    },
    categoriesTitle: {
      margin: "0 0 20px 0",
      color: "#182848",
      fontSize: "20px",
      fontWeight: "600",
      display: "flex",
      alignItems: "center",
      gap: "10px"
    },
    categoryItem: {
      backgroundColor: "#f8f9fa",
      borderRadius: "10px",
      padding: "15px",
      marginBottom: "15px",
      borderLeft: "4px solid #4b6cb7",
      transition: "all 0.3s"
    },
    categoryHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "10px"
    },
    categoryName: {
      margin: "0",
      color: "#182848",
      fontSize: "18px",
      fontWeight: "600"
    },
    subcategoriesList: {
      margin: "15px 0 0 0",
      paddingLeft: "25px",
      listStyleType: "none"
    },
    subcategoryItem: {
      backgroundColor: "white",
      borderRadius: "8px",
      padding: "12px 15px",
      marginBottom: "10px",
      borderLeft: "3px solid #6c757d",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    subcategoryName: {
      margin: "0",
      color: "#495057",
      fontSize: "16px"
    },
    emptyMessage: {
      textAlign: "center",
      padding: "40px 20px",
      color: "#6c757d",
      fontSize: "16px"
    },
    icon: {
      width: "24px",
      height: "24px",
      color: "#4b6cb7"
    },
    successIcon: {
      width: "20px",
      height: "20px",
      color: "#155724"
    },
    errorIcon: {
      width: "20px",
      height: "20px",
      color: "#721c24"
    }
  };

  // أيقونات SVG
  const CategoryIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={styles.icon}>
      <path fillRule="evenodd" d="M5.25 2.25a3 3 0 00-3 3v4.318a3 3 0 00.879 2.121l9.58 9.581c.92.92 2.39 1.186 3.548.428a18.849 18.849 0 005.441-5.44c.758-1.16.492-2.629-.428-3.548l-9.58-9.581a3 3 0 00-2.122-.879H5.25zM6.375 7.5a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z" clipRule="evenodd" />
    </svg>
  );

  const ListIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={styles.icon}>
      <path fillRule="evenodd" d="M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z" clipRule="evenodd" />
    </svg>
  );

  const SuccessIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={styles.successIcon}>
      <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
    </svg>
  );

  const ErrorIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={styles.errorIcon}>
      <path fillRule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clipRule="evenodd" />
    </svg>
  );

  // دالة للتعامل مع التركيز على الحقول
  const handleInputFocus = (e) => {
    e.target.style.outline = "none";
    e.target.style.borderColor = "#4b6cb7";
    e.target.style.boxShadow = "0 0 0 3px rgba(75, 108, 183, 0.1)";
    e.target.style.backgroundColor = "white";
  };

  const handleInputBlur = (e) => {
    e.target.style.borderColor = "#e1e5eb";
    e.target.style.boxShadow = "none";
    e.target.style.backgroundColor = "#f8f9fa";
  };

  // دالة للتعامل مع hover على الأزرار
  const handleButtonHover = (e, isDelete = false) => {
    if (isDelete) {
      e.target.style.backgroundColor = "#c82333";
      e.target.style.transform = "translateY(-2px)";
      e.target.style.boxShadow = "0 4px 8px rgba(220, 53, 69, 0.2)";
    } else {
      e.target.style.transform = "translateY(-2px)";
      e.target.style.boxShadow = "0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08)";
    }
  };

  const handleButtonLeave = (e, isDelete = false) => {
    if (isDelete) {
      e.target.style.backgroundColor = "#dc3545";
      e.target.style.transform = "translateY(0)";
      e.target.style.boxShadow = "none";
    } else {
      e.target.style.transform = "translateY(0)";
      e.target.style.boxShadow = "none";
    }
  };

  return (
    <div style={styles.container}>
      {/* الرأس */}
      <div style={styles.header}>
        <h1 style={styles.title}>إدارة الفئات</h1>
      </div>

      {/* بطاقة إضافة فئة جديدة */}
      <div style={styles.card}>
        <h2 style={styles.cardTitle}>
          <CategoryIcon />
          إضافة فئة جديدة
        </h2>
        
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.formGroup}>
            <label htmlFor="name" style={styles.label}>اسم الفئة</label>
            <input
              id="name"
              placeholder="أدخل اسم الفئة الجديدة"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              onFocus={handleInputFocus}
              onBlur={handleInputBlur}
              required
              style={styles.input}
            />
          </div>

          <div style={styles.formGroup}>
            <label htmlFor="parent" style={styles.label}>الفئة الرئيسية</label>
            <select
              id="parent"
              value={form.parent_id || ""}
              onChange={(e) => setForm({ ...form, parent_id: e.target.value || null })}
              onFocus={handleInputFocus}
              onBlur={handleInputBlur}
              style={styles.select}
            >
              <option value="">فئة رئيسية (لا توجد فئة أب)</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>

          <button 
            type="submit" 
            disabled={loading}
            style={{
              ...styles.button,
              ...(loading ? styles.buttonDisabled : {})
            }}
            onMouseEnter={(e) => handleButtonHover(e, false)}
            onMouseLeave={(e) => handleButtonLeave(e, false)}
          >
            {loading ? (
              <>
                <div style={styles.spinner}></div>
                جاري الإضافة...
              </>
            ) : (
              "إضافة الفئة"
            )}
          </button>

          {/* رسائل النجاح والخطأ */}
          {success && (
            <div style={styles.successMessage}>
              <SuccessIcon />
              {success}
            </div>
          )}

          {error && (
            <div style={styles.errorMessage}>
              <ErrorIcon />
              {error}
            </div>
          )}
        </form>
      </div>

      {/* بطاقة عرض الفئات */}
      <div style={styles.categoriesContainer}>
        <h2 style={styles.categoriesTitle}>
          <ListIcon />
          الفئات الحالية ({categories.length})
        </h2>

        {categories.length === 0 ? (
          <div style={styles.emptyMessage}>
            لا توجد فئات مضافة حتى الآن. قم بإضافة فئة جديدة لتبدأ.
          </div>
        ) : (
          <div>
            {categories.map((cat) => (
              <div key={cat.id} style={styles.categoryItem}>
                <div style={styles.categoryHeader}>
                  <h3 style={styles.categoryName}>{cat.name}</h3>
                  <button
                    style={styles.deleteButton}
                    onClick={() => handleDelete(cat.id)}
                    onMouseEnter={(e) => handleButtonHover(e, true)}
                    onMouseLeave={(e) => handleButtonLeave(e, true)}
                  >
                    حذف الفئة
                  </button>
                </div>

                {/* الفئات الفرعية */}
                {cat.children && cat.children.length > 0 && (
                  <ul style={styles.subcategoriesList}>
                    {cat.children.map((child) => (
                      <li key={child.id} style={styles.subcategoryItem}>
                        <span style={styles.subcategoryName}>{child.name}</span>
                        <button
                          style={styles.deleteButton}
                          onClick={() => handleDelete(child.id)}
                          onMouseEnter={(e) => handleButtonHover(e, true)}
                          onMouseLeave={(e) => handleButtonLeave(e, true)}
                        >
                          حذف
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* إضافة أنيميشن الـ spinner */}
      <style>{`
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
        
        @media (max-width: 768px) {
          .form-row {
            flex-direction: column;
          }
          
          .category-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
          }
          
          .category-header h3 {
            margin-bottom: 10px;
          }
        }
      `}</style>
    </div>
  );
}